import type {
  LoginAction,
  SignupAction,
  ConfirmSignupAction,
  LoadLoginAction,
} from "./types";
export function login(
  email: string,
  password: string,
  callback?: () => void
): LoginAction {
  return {
    type: "LOGIN",
    email,
    password,
    callback,
  };
}
export function signup(email: string, password: string): SignupAction {
  return {
    type: "SIGNUP",
    email,
    password,
  };
}
export function confirmSignup(
  confirmCode: string,
  email: string,
  password?: string
): ConfirmSignupAction {
  return {
    type: "CONFIRM_SIGNUP",
    confirmCode,
    password,
    email,
  };
}
export function loadLogin(): LoadLoginAction {
  return {
    type: "LOAD_LOGIN",
  };
}
